import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download_staging/69ba99377d947e001469cf93/upskill_1773836599114/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69ba99377d947e001469cf93/upskill_1773836599114/src/styles/tailwind.css");
